/* Timed translations follow the site language; German always keeps captions off. */
(() => {
  const viewer=document.querySelector('.craft-viewer'),video=document.querySelector('#craft-film');
  if(!viewer||!video)return;
  const languages={en:'English',ku:'Kurdî (Kurmancî)',tr:'Türkçe',ar:'العربية'};
  const captionedClips=new Set(['packing']);
  const tracks=new Map();let clip='';
  function sync(){
    const language=document.documentElement.lang;
    for(const [code,element] of tracks){
      const active=language===code;
      if(element.default!==active)element.default=active;
      const mode=active?'showing':'disabled';
      if(element.track.mode!==mode)element.track.mode=mode;
    }
    viewer.dataset.subtitleLanguage=tracks.has(language)?language:'off';
  }
  function selectClip(){
    const next=viewer.dataset.clip||'packing';
    if(next===clip){sync();return;}
    clip=next;
    for(const element of tracks.values()){element.track.mode='disabled';element.remove();}
    tracks.clear();
    if(captionedClips.has(clip)){
      for(const [code,label] of Object.entries(languages)){
        const element=document.createElement('track');
        element.kind='subtitles';element.srclang=code;element.label=label;
        element.src=window.KM.asset(`/assets/subtitles/${clip}.${code}.vtt?v=28`);
        element.addEventListener('load',sync);
        video.append(element);element.track.mode='disabled';tracks.set(code,element);
      }
    }
    sync();
  }
  viewer.addEventListener('craftclipchange',selectClip);
  document.addEventListener('sitelanguagechange',sync);
  video.addEventListener('loadedmetadata',sync);
  // Also enforce the language after a browser restores its text-track preference.
  video.textTracks.addEventListener('change',sync);
  selectClip();
})();
